import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IBankAccount } from '../../../../shared/model/bank-account.model';
import { BankAccountService } from '../../../../shared/services/bank-account.service';
import { IImportSettingsMcbSftp } from './import-settings-mcb-sftp.model';
import { ImportSettingsMcbSftpService } from './import-settings-mcb-sftp.service';

@Component({
  selector: 'app-import-settings-mcb-sftp',
  templateUrl: './import-settings-mcb-sftp.component.html',
  styleUrls: ['./import-settings-mcb-sftp.component.scss']
})
export class ImportSettingsMcbSftpComponent implements OnInit {

  @Input()
  public bankAccount!: IBankAccount;

  public form = new FormGroup({
    host: new FormControl('', Validators.required),
    port: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    folder: new FormControl({ value: '', disabled: true }, Validators.required),
  });

  constructor(
    private bankAccountService: BankAccountService,
    private importSettingsMcbSftpService: ImportSettingsMcbSftpService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    this.importSettingsMcbSftpService.get(this.bankAccount.id).subscribe((settings) => {
      this.form.patchValue(settings);
    });
  }

  public save(): void {
    if (this.form.valid) {
      const settings = this.parseSettings();
      const bankAccountId = this.bankAccount.id;
      const saveBankAccount = this.bankAccountService.update(this.bankAccount);
      const saveSettings = this.importSettingsMcbSftpService.save(bankAccountId, settings);
      Promise.all([
        saveBankAccount,
        saveSettings,
      ]).then(() => {
        this.router.navigate(['/bank-accounts', bankAccountId]);
      });
    }
  }

  private parseSettings(): IImportSettingsMcbSftp {
    return {
      host: this.form.get('host')?.value,
      port: this.form.get('port')?.value,
      username: this.form.get('username')?.value,
      password: this.form.get('password')?.value,
      folder: this.form.get('folder')?.value,
    };
  }

}
